import { create } from 'zustand'
import { SingleLocation } from '@/routes/projectStages/issue/types/issue.ts'
import {
  FORCE_LAST_SELECTED_LOCATION,
  LOCAL_STORAGE_LAST_SELECTED_LOCATION_KEY,
} from '@/lib/constants/constants.ts'

type LocationMapStore = {
  showMap: boolean
  setShowMap: (showMap: boolean) => void
  mapUrl: string | null
  setMapUrl: (mapUrl: string) => void
  coords: { x: number; y: number } | null
  setCoords: (coords: { x: number; y: number }) => void
  selectedLocation: SingleLocation | null
  setSelectedLocation: (selectedLocation: SingleLocation | null) => void
  selectedDropdownLocation: SingleLocation | null
  setSelectedDropdownLocation: (selectedLocation: SingleLocation | null) => void
  hoveredLocationCode: string | null
  setHoveredLocationCode: (hoveredLocationCode: string | null) => void
  resetValues: () => void
  setType: (type: 'issueMap' | 'previewMap') => void
  type: 'issueMap' | 'previewMap'
  initializeSelectedLocationFromLocalStorage: (
    findLocationByIri: (locations: SingleLocation[], iri: string) => SingleLocation | null,
    stageLocations: SingleLocation[],
  ) => void
}

export const useLocationMapStore = create<LocationMapStore>(set => ({
  showMap: false,
  setShowMap: showMap => set({ showMap }),
  mapUrl: null,
  setMapUrl: mapUrl => set({ mapUrl }),
  coords: null,
  setCoords: coords => set({ coords }),
  selectedLocation: null, // Initialized to null, will be updated by action
  setSelectedLocation: selectedLocation => set({ selectedLocation }),
  selectedDropdownLocation: null, // Initialized to null, will be updated by action
  setSelectedDropdownLocation: selectedDropdownLocation => set({ selectedDropdownLocation }),
  hoveredLocationCode: null,
  setHoveredLocationCode: hoveredLocationCode => set({ hoveredLocationCode }),
  resetValues: () =>
    set({
      showMap: false,
      mapUrl: null,
      coords: null,
      selectedLocation: null,
      selectedDropdownLocation: null,
      type: 'issueMap',
    }),
  setType: type => set({ type }),
  type: 'issueMap',

  initializeSelectedLocationFromLocalStorage: (findLocationByIri, stageLocations) => {
    const forceSelect = localStorage.getItem(FORCE_LAST_SELECTED_LOCATION)
    if (forceSelect === 'true') {
      const lastSelectedLocationIri = localStorage.getItem(LOCAL_STORAGE_LAST_SELECTED_LOCATION_KEY)
      if (lastSelectedLocationIri) {
        setTimeout(() => {
          const location = findLocationByIri(stageLocations, lastSelectedLocationIri)
          if (location) {
            set({
              selectedLocation: location,
              selectedDropdownLocation: location,
              hoveredLocationCode: null,
            })
          }
        }, 0)
      }
    }
  },
}))

export default useLocationMapStore
